import queryString from 'query-string'
import { useHistory, useLocation } from 'react-router-dom'
import styled from 'styled-components/macro'

import { Button, EmptyState, Layout, Text } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import IconLoadsmart from 'core/ui/assets/icon-loadsmart.svg'
import IllustrationDepartingTruck from 'core/ui/assets/illustration-departing-truck.svg'

import { user } from 'legacy/utils/user'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${getToken('space-3xl')};
`
type EmptyStateProps = {
  kind: 'single' | 'bulk'
}

export function EmptySpotQuoteState({ kind = 'single' }: EmptyStateProps) {
  const shouldDisplaySignUpButton = !user.isLoggedIn()

  const location = useLocation()
  const history = useHistory()

  function handleOnSignUpButtonClick() {
    const search = queryString.parse(location.search)
    search['signup'] = 'true'

    history.replace({
      search: queryString.stringify(search),
    })
  }

  return (
    <Wrapper>
      <Layout.Stack space="m" align="center">
        <EmptyState
          illustration={IllustrationDepartingTruck}
          title="Oops! Nothing here."
          description="Looks like the page you're looking for does not exist or is not available anymore."
          variant="page"
        />
        <Text variant="body-bold">
          Go to our carrier platform and find spot loads to keep your truck full
        </Text>
        {shouldDisplaySignUpButton && (
          <Layout.Group>
            <Button
              variant="primary"
              leading={<img src={IconLoadsmart} alt="" />}
              onClick={handleOnSignUpButtonClick}
            >
              Sign up to start booking
            </Button>
          </Layout.Group>
        )}
      </Layout.Stack>
    </Wrapper>
  )
}
